import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

export interface PaqueteFleteSingle {
    Peso: number;
    Alto: number;
    Largo: number;
    Ancho: number;
}

export interface PaquetesFlete extends PaqueteFleteSingle {
    Cantidad: number;
}

export interface PaquetesFleteImportes extends PaquetesFlete {
    Importes: models.ImportesServicio;
}

/**Formatea un volumen */
export function formatearVolumen(x: { Alto: number, Largo: number, Ancho: number }): string {
    return ` ${x.Largo}x${x.Alto}x${x.Ancho} cm`;
}

/**Convierte un paquete a cadena */
export function paqueteToString(x: { Peso: number, Alto: number, Largo: number, Ancho: number }) {
    return `${x.Peso} kg ${formatearVolumen(x)}`;
}

/**Convierte un paquete a cadena */
export function paqueteCantToString(x: { Peso: number, Alto: number, Largo: number, Ancho: number, Cantidad: number }) {
    const p = paqueteToString(x);
    return `${x.Cantidad} x (${p})`;
}

export function paqueteToReact(x: { Peso: number, Alto: number, Largo: number, Ancho: number }): JSX.Element {
    return <span ><i className={fa("balance-scale", "fw")} />{x.Peso} kg <i className={fa("cube", "fw")} />{x.Alto}×{x.Largo}×{x.Ancho} cm</span>
}



// WEBPACK FOOTER //
// ./app/logic/operativa/paquetes.tsx